// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"b36ea92e","359":"f1d66522"}[chunkId] + ".chunk.js";
};